import { Box, Typography } from '@mui/material';

export default function EmptyReport() {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '200px',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Typography variant="body1" textAlign="center">
        No data found over the date range selected
      </Typography>
    </Box>
  );
}
